import React, { useState, useEffect } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import "./contact.css";
import toast, { Toaster } from "react-hot-toast";
import { submitContactUsForm } from "../../Action/action";
import { useNavigate } from "react-router-dom";
import Security from "../LaunchpadHome/SubFooter";
import { Link } from "react-router-dom";
import config from "../../config/config";

export default function Contactus() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    agree: false,
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const validateForm = async () => {
    const newErrors = {};
    if (!form.name) newErrors.name = "Name is required";
    if (!form.email) newErrors.email = "Email is required";
    if (!form.message) newErrors.message = "Message is required";
    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCall = async (e) => { };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (await validateForm()) {
      //console.log("Form submitted", form);
      let result = await submitContactUsForm(form);
      console.log("Res", result);
      if (result.success) {
        toast.success(
          "Submitted successfully. Please wait we will contact you soon"
        );
        setForm({ name: "", email: "", phone: "", message: "" });
        setErrors({});
      } else {
        toast.error("Error submitting form. Please try after sometime");
      }
    } else {
      toast.error("Please check the validations required.");
    }
  };

  return (
    <>
      <Toaster />
      <Header />
      <div className="bg-darkgrey">
        <section className="contact py-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div>
                  <h1 className="text-white">Contact Us</h1>
                  <div className=" mt-4">
                    <Row>
                      <Col lg={8} className="mb-4">
                        <Form>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="text-white">Name</Form.Label>
                            <Form.Control
                              type="text"
                              name="name"
                              onChange={handleChange}
                              value={form.name}
                              isInvalid={!!errors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.name}
                            </Form.Control.Feedback>
                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="text-white">
                              Email
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="email"
                              onChange={handleChange}
                              value={form.email}
                              isInvalid={!!errors.email}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.email}
                            </Form.Control.Feedback>
                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className="text-white">
                              Phone
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="phone"
                              onChange={handleChange}
                              value={form.phone}
                              isInvalid={!!errors.phone}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.phone}
                            </Form.Control.Feedback>
                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                          >
                            <Form.Label className="text-white">
                              Message
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              name="message"
                              rows={3}
                              onChange={handleChange}
                              value={form.message}
                              isInvalid={!!errors.message}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.message}
                            </Form.Control.Feedback>
                          </Form.Group>

                          <Button
                            variant="custombtn"
                            className="px-3"
                            onClick={handleSubmit}
                          >
                            Submit
                          </Button>
                        </Form>
                      </Col>
                      <Col lg={4} className="mb-4">
                        <div class="contact-address p-3 mb-4">
                          <div class="">
                            <div class="text-uppercase fw-bolder mb-1 text-white fs-4">
                              Our location
                            </div>
                            <p class="mb-0 text-light-grey2">
                              INFI MultiChain CDEX is a fully
                              decentralized, globally governed protocol
                              powered by DAO voting and self-executing
                              smart contracts—owned and shaped by its
                              community.
                            </p>
                          </div>
                        </div>
                        <div class="mb-5">
                          <p>
                            <Button
                              variant="custombtn"
                              className="px-3"
                              onClick={(e) => {
                                e.preventDefault();
                                window.open(
                                  "https://calendly.com/infimultichain-support/30min",
                                  "_blank"
                                );
                              }}
                            >
                              Book a call with us
                            </Button>
                          </p>
                        </div>
                        <div class="">
                          <div class="text-uppercase text-white fw-bolder mb-1 fs-4 ">
                            Email us
                          </div>
                          <p class=" mb-0 text-light-grey2">
                            <a
                              href="mailto: support@infimultichain.com"
                              className="me-3 text-decoration-none d-inline-block"
                            >
                              {" "}
                              support@infimultichain.com
                            </a>
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="Security position-relative pt-0 pb-0">
          <Container className="py-5 position-relative">
            <Row className="justify-content-center align-items-center py-2">
              <Col lg={12} className="pb-5 security-card">
                <div className="bookshap">
                  <img src="images/book.png" alt="" />
                </div>
                <Card className="bg-transparent border border-dark p-5">
                  <Row className="justify-content-center">
                    <Col xl={12} lg={10}>
                      <div className="security-detail p-md-5 pt-5">
                        <h2 className="text-white mb-4 text-center">
                          Leveraging the{" "}
                          <span className="text-primary-gradient">
                            ©SbSe Protocol,
                          </span>{" "}
                          INFI establishes a transparent, decentralised and
                          community-driven financial infrastructure, setting a
                          new standard for innovation in the blockchain space.
                        </h2>
                      </div>
                      <div className="buyInfi">
                        <Button
                          variant="default"
                          className="btn-white-gradient fw-bold text-black px-4 rounded-5 position-relative z-2 me-3"
                          href={`${config.baseUrl}`}
                        >
                          INFI HUB&nbsp;&nbsp;&nbsp;
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="16"
                            viewBox="0 0 24 19"
                            fill="none"
                          >
                            <path
                              d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Button>
                        <Button
                          className="px-4 rounded-5 bg-black  position-relative z-2 me-3 border"
                          href={`${config.baseUrl}launchpad`}
                        >
                          INFI Launchpad&nbsp;&nbsp;&nbsp;
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="16"
                            viewBox="0 0 24 19"
                            fill="none"
                          >
                            <path
                              d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Button>

                        <Button
                          variant="custombtn"
                          className="text-black px-4 rounded-5 position-relative z-2 text-uppercase"
                          as={Link}
                          to="https://infimultichain.com/exch/"
                        >
                          Staking & Rewards&nbsp;&nbsp;&nbsp;
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="16"
                            viewBox="0 0 24 19"
                            fill="none"
                          >
                            <path
                              d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Container>
          <div className="bg-shape3 ">
            <img src="images/bg-shape3.png" alt="" />
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
